export default "__VITE_ASSET__97656115__"